// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"1b73bcd4","424":"8106a71a","485":"ad2fd2e3"}[chunkId] + ".chunk.js";
};